export default {"src":"/_next/static/media/badge.03fee5d3.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};